// extracted by mini-css-extract-plugin
export default {"pageWrap":"xc-z","fullWidth":"yc-z","heading":"zc-z","fullBleed":"Ac-z","hidden":"Bc-z"};